import { Grid } from '@mui/material';
import React from 'react';
import { dateformat } from '../helpers';
import { useNotification } from '../helpers/Notification';
import { FechaField } from '../modules/accesos/components/FechaField';

const FechasPersonalizada = ({
  mdStart = 3,
  mdEnd = 3,
  startDate,
  endDate,
  onStart = () => {},
  onEnd = () => {},
}) => {
  const { notify } = useNotification();

  return (
    <>
      <Grid item md={mdStart}>
        <FechaField
          label="Desde"
          value={startDate}
          onChange={(e) => {
            const newDate = dateformat(e, {});
            if (new Date(newDate) > new Date(endDate)) {
              notify('La fecha no puede ser mayor que la fecha final', {
                error: true,
              });
              return onStart(null);
            }
            return onStart(newDate);
          }}
        />
      </Grid>
      <Grid item md={mdEnd}>
        <FechaField
          label="Hasta"
          value={endDate}
          onChange={(e) => {
            const newDate = dateformat(e, {});
            if (new Date(newDate) < new Date(startDate)) {
              notify('La fecha no puede ser menor que la fecha inicial', {
                error: true,
              });
              return onEnd(null);
            }
            return onEnd(newDate);
          }}
        />
      </Grid>
    </>
  );
};

export default FechasPersonalizada;
